import {Alert} from 'react-native'
import swal from "sweetalert";

const latinToPersianMap = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰'];
const latinNumbers = [/1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g, /0/g];
const session = ['اول', 'دوم', 'سوم', 'چهارم', 'پنجم', 'ششم', 'هفتم', 'هشتم', 'نهم', 'دهم', 'یازدهم', 'دوازدهم', 'سیزدهم', 'چهاردهم', 'پانزدهم', 'شانزدهم', 'نوزدهم', 'بیستم'];

export function getError(response) {
    var error = '';
    if (response.errors != null) {
        response.errors.map(item => {
            error += item + " \n";
        })
    }
    if (error.length <= 2) {
        error = response.message;
    }
    return error;
}

export function persianNumber(number) {
    if (number == null) {
        number = '';
    }
    number = number.toString();
    for (var index = 0; index < 10; index++) {
        number = number.replace(latinNumbers[index], latinToPersianMap[index]);
    }
    return number;
}

export function englishNumber(number) {
    if (number == null) {
        number = '';
    }
    number = number.toString();
    for (var index = 0; index < 10; index++) {
        number = number.replace(latinToPersianMap[index], latinNumbers[index]);
    }
    return number;
}

export function priceString(price) {
    if (price == null) {
        price = '';
    }
    price = price.toString();
    price = price.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1" + ",")
    for (var index = 0; index < 10; index++) {
        price = price.replace(latinNumbers[index], latinToPersianMap[index]);
    }
    return price;
}

export function getStatusPay(status) {
    if (status == 'cpay') {
        return 'نقدی'
    } else if (status == 'paid') {
        return 'آنلاین'
    } else if (status == 'bag') {
        return 'کیف پول'
    } else if (status == 'backprice') {
        return 'برگشت خورده'
    } else {
        return 'پرداخت'
    }
}

export function getStatusServant(status) {
    if (status == 'arrived') {
        return 'در حال انجام'
    } else if (status == 'start') {
        return 'در حال انجام'
    } else {
        return 'تکمیل شده'
    }
}

export function getStatus(showsession, status, session) {
    if (!showsession) {
        if (status.includes('waitting')) {
            return 'در انتظار خدمت دهنده'
        } else if (status.includes('getservant')) {
            return 'پذیرفته شده'
        } else if (status.includes('arrived')) {
            return 'در حال انجام'
        } else if (status.includes('cancelled')) {
            return 'لغو شده'
        } else if (status.includes('end')) {
            return 'اتمام کار'
        }
    } else {
        if (session != null && status.includes('end')) {
            return 'تکمیل شده';
        } else if (session != null && status.includes('cancelled')) {
            return 'لغو شده'
        } else if (session != null && status.includes('waitting')) {
            return 'در انتظار خدمت دهنده'
        } else {
            return session;
        }
    }
}

export function getStatusColor(showsession, status, session) {
    if (!showsession) {
        if (status.includes('waitting')) {
            return '#CF8C31'
        } else if (status.includes('getservant')) {
            return '#319ECF'
        } else if (status.includes('cancelled')) {
            return '#d32f2f'
        } else if (status.includes('arrived')) {
            return '#FF6555'
        } else if (status.includes('end')) {
            return '#31CF75'
        }
    } else {
        if (session != null && status.includes('end')) {
            return '#31CF75';
        } else if (session != null && status.includes('cancelled')) {
            return '#d32f2f'
        } else if (session != null && status.includes('waitting')) {
            return '#CF8C31'
        } else {
            return '#FF6555';
        }
    }
}

export const showPrompt = (title, message, onApprove) => {
    swal(message, {
        dangerMode: true,
        buttons: {
            cancel: 'خیر',
            confirm:'بلی'
        },
    }).then(r => {
        if(r)
        {
            onApprove()
        }else {
            console.log('cancel')
        }

    } ).catch(error=>{
        console.log('error')
    });
}

export const showPromptDownload = (title, message, onApprove, onCancel, needupdate) => {
    Alert.alert(
        title.toString(),
        message.toString(), [
            {text: needupdate == 'yes' ? 'خروج' : 'بعدا', onPress: () => onCancel(), style: 'cancel'},
            {text: 'دانلود', onPress: () => onApprove(), style: 'cancel'},
        ],
        {cancelable: needupdate == 'yes'})
}
export const showMessage = (title, message) => {
    swal(message.toString(), {
        dangerMode: false,
        buttons: {
            confirm:'باشه'
        },
    }).then(r => {
        if(r)
        {
           console.log('')
        }else {
            console.log('')
        }

    } ).catch(error=>{
        console.log('error')
    });
}
export const showMessageCallback = (title, message, callback) => {
    swal(message.toString(), {
        dangerMode: false,
        buttons: {
            confirm:'باشه'
        },
    }).then(r => {
        if(r)
        {
            callback();
        }else {
            callback();
        }

    } ).catch(error=>{
        console.log('error')
    });

}

export function getNumber(number) {
    return session[number - 1];
}
